import { ReviewStatus } from './services/api.service';

export const PolicySetKey = 'POLICY_SET';
export const TokenKey = 'LOCAL_TOKEN';
export const Production = 'Production';
export enum AuthenticationMethods {
  adeConnect = 'adeConnect',
  test = 'test',
}
export const MinAge = 15;
export const MaxAge = 150;

export enum FormEvents {
  Successful,
  Error,
  Cancelled,
}
export const AzStateCode = 'AZ';
export const DeclinedToAnswerCode = 'D';
export enum ApplicationGroupCodes {
  Add = 'ADD',
  Maintain = 'MNT',
  Other = 'OTH',
}
export enum CertificateLevelCodes {
  Alt = 'alt',
  Interim = 'interim',
  STIC = 'stic',
  Emerg = 'emerg',
  Intl = 'intl',
}
export enum ApplicationOptionCodes {
  AdCert = 'adcert',
  Adda = 'adaa',
  Adend = 'adend',
  Adircert = 'adircert',
  Adirend = 'adirend',
  Ren = 'ren',
  Defrmv = 'defrmv',
  Ext = 'ext',
  Nmchng = 'nmchng',
  Copy = 'copy',
  Ssnchng = 'ssnchng',
  Reinstate = 'reinstate',
}
export enum ServiceCodes {
  AddCert = '25',
  AddArea = '23',
  AddEndorsement = '21',
  AddIRCert = '88',
  AddIREndorsement = '26',
  Renewal = '74',
  DeficiencyRemoval = '77',
  Extension = '120',
  NameChange = '75',
  CopyCert = '76',
  SSNChange = '109',
  Alignment = '119',
  ReinstateCertificate = '121',
}
export enum ContactTypeCodes {
  None = 'NN',
  Phone = 'PH',
  Email = 'EM',
  Counter = 'CTR',
  Offsite = 'OS',
}
export enum NoteTypes {
  EducatorNoteDto = 'EducatorNoteDto',
  EducatorSystemEventDto = 'EducatorSystemEventDto',
  EducatorAlertDto = 'EducatorAlertDto',
}

export const ScannerResourcesPath = 'assets/dwt-resources';

export const ApplicationBuildingStatus = 'Building';

export enum ApplicationStatus {
  Building = 'building',
  Accepted = 'accepted',
  ReturnedIncomplete = 'returned incomplete',
  Open = 'open',
  Closed = 'closed',
}

export const AccreditedInstitutionOtherCode = 'other';
export const NonePaymentTypeCode = 'none';
export const ValidStatus = 'valid';
export const ValidManualStatus = 'valid - manually entered';

export const ValidCertificateStatusCode = 'VAL';

export enum ServiceStatuses {
  Received = 'Received',
  Cancelled = 'Cancelled',
  AdministrativeIncomplete = 'AdministrativeIncomplete',
  SubstantiveIncomplete = 'SubstantiveIncomplete',
  SubstantiveReview = 'SubstantiveReview',
  Denied = 'Denied',
  Appealed = 'Appealed',
  Issued = 'Issued',
}

export enum MyServicesFilters {
  HasMaterialsReceived = 'hasMaterialsReceived',
  IsReceivedStatus = 'isReceivedStatus',
  IsAdministrativeReviewStatus = 'isAdministrativeReviewStatus',
  IsSubstantiveReviewStatus = 'isSubstantiveReviewStatus',
  IsAdministrativeIncompleteStatus = 'isAdministrativeIncompleteStatus',
  IsSubstantiveIncompleteStatus = 'isSubstantiveIncompleteStatus',
  IsRushed = 'isRushed',
}

export enum ServiceItemsAdminFilters {
  AppealedStatus = 'hasAppealedStatus',
  FinalSIReviewStatus = 'hasFinalSIReviewStatus',
  IsRushed = 'isRushed',
}

export enum PaymentReversalReportFilters {
  Is30daysOld = 'is30DaysOld',
  Is90daysOld = 'is90DaysOld',
  IsYearOld = 'isYearOld',
  IsInCollections = 'isInCollections',
}

export enum FingerprintCardValidityStatus {
  Valid = 'Valid',
  NotValid = 'Not Valid',
  Pending = 'Pending',
  NotOnFile = 'Not On File',
  Expired = 'Expired',
}

export enum PaymentTypes {
  Check = 'Check',
  CreditCard = 'Credit Card',
  MoneyOrder = 'Money Order',
  NoPayment = 'No Payment',
  Redeposit = 'Redeposit',
}

export enum SubRequirementGroupType {
  Alternative = 0,
  Composite = 1,
}

export const FullEndorsementLevel = 'full';

export enum EndorsementLevelCodes {
  Full = 'Full',
  Provisional = 'Prov',
  Emergency = 'Emerg',
}

export enum RouteType {
  Primary,
  Cert,
  Lea,
  Epp,
  Lea2,
}

export enum Portal {
  Cert = 'cert',
  Lea = 'lea',
  Epp = 'epp',
  Lea2 = 'lea2',
}

export enum LeaEducatorRosterFilters {
  HasInvalidIvpFingerprint = 'ivpStatus',
  HasExpiredIvpFingerprint = 'expiredIvpStatus',
  NeedsProfessionalDevelopment = 'needsProfessionalDevelopment',
  HasRenewableCertificates = 'hasRenewableCertificates',
  HasDeficiencies = 'hasDeficiencies',
  IsUnderInvestigation = 'isUnderInvestigation',
}

export enum LeaStaffRosterFilters {
  HasInvalidIvpFingerprint = 'hasInvalidIvpFingerprint',
  HasExpiredIvpFingerprint = 'hasExpiredIvpFingerprint',
  NeedsProfessionalDevelopment = 'needsProfessionalDevelopment',
  HasRenewableCertificates = 'hasRenewableCertificates',
  HasDeficiencies = 'hasDeficiencies',
  NotAppropriatelyCertified = 'notAppropriatelyCertified',
  IsUnderInvestigation = 'isUnderInvestigation',
  IsEmptyDistrictEmployment = 'isEmptyDistrictEmployment',
  IsFilledDistrictEmployment = 'isFilledDistrictEmployment',
  IsEmptySiteEmployment = 'isEmptySiteEmployment',
  IsFilledSiteEmployment = 'isFilledSiteEmployment',
}

export enum TitleIStatusFilters {
  HasMissingTitleIStatus = 'hasMissingTitleIStatus',
  HasNonTitleIStatus = 'hasNonTitleIStatus',
  HasTargetedTitleIStatus = 'hasTargetedTitleIStatus',
  HasSchoolWideITitleIStatus = 'hasSchoolWideITitleIStatus',
  HasSchoolWideIITitleIStatus = 'hasSchoolWideIITitleIStatus',
  HasSchoolWideIIITitleIStatus = 'hasSchoolWideIIITitleIStatus',
}

export enum StaffStatusFilters {
  TeachingValidIvp = 'teachingValidIvp',
  SupportStaffValidIvp = 'supportStaffValidIvp',
  FingerprintIssues = 'fingerprintIssues',
  DisciplineHistory = 'disciplineHistory',
  UnderInvestigation = 'underInvestigation',
  ValidCertificates = 'validCertificates',
  AppropriatelyCertified = 'appropriatelyCertified',
  OnEtc = 'onEtc',
  OnEsc = 'onEsc',
  OnAltCert = 'onAltCert',
}

export enum ReportPlacements {
  ReportsPage = 'ReportsPage',
  Dashboard = 'Dashboard',
}

export enum LeaStaffPositionsFilters {
  Vacancy = 'hasVacancyStatus',
  SubfillingVacancy = 'hasSubfillingVacancyStatus',
  SubfillingFmlaLoa = 'hasSubfillingFmlaLoaStatus',
}

export enum LeaStaffPositionsStatusCodes {
  Vacancy = 'V',
  Filled = 'F',
  SubFillingFmlaLoa = 'SL',
  SubFillingVacancy = 'SV',
  Closed = '01',
}

export enum MimeType {
  PDF = 'application/pdf',
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  CSV = 'text/csv',
  Image = 'image/png,image/jpeg,image/webp,image/gif',
}

export enum IRSpreadsheetNames {
  Programs = 'Programs',
  Certificates = 'Certificates',
  Endorsements = 'Endorsements',
  RequirementsMet = 'RequirementsMet',
}

export const ReviewStatusOptions = [
  { value: ReviewStatus.Reviewed, label: 'Reviewed' },
  { value: ReviewStatus.PendingReview, label: 'Pending Review' },
  { value: ReviewStatus.Rejected, label: 'Rejected' },
];

export const ArizonaDepartmentOfEd = '79275';

export enum ConfigCredentialType {
  Certificates = 'certificates',
  Areas = 'areas',
  Endorsements = 'endorsements',
  Deficiencies = 'deficiencies',
  PublicCertificateGroups = 'public-certificate-groups',
  PublicEndorsementGroups = 'public-endorsement-groups',
}

export enum ConfigMode {
  Add = 'add',
  Edit = 'edit',
  View = 'view',
  Copy = 'copy',
}

export enum AssignmentStatusCodes {
  Active = '1',
  LOA = '2',
  FMLA = '3',
  Ended = '4',
}

export enum PositionClassificationCodes {
  Administrative = 'A',
  Classified = 'C',
  ProfessionalNonTeaching = 'P',
  Teacher = 'T',
}

export enum EvaluationRole {
  Teacher = 'Teacher',
  Principal = 'Principal',
}

export enum ScopeTypes {
  AllDistricts = 'All Districts',
  PublicDistricts = 'Public Districts',
  CharterDistricts = 'Charter Districts',
  AllSites = 'All Sites',
  PublicSites = 'Public Sites',
  CharterSites = 'Charter Sites',
  Custom = 'Custom',
}

export enum PDRequestStatus {
  Pending = 'Pending',
  Fulfilled = 'Fulfilled',
  Rejected = 'Rejected',
}

export enum PDVerificationRequestStatus {
  Pending = 'Pending',
  Verified = 'Verified',
  Rejected = 'Rejected',
}

export enum PDSource {
  Educator = 'Educator',
  LEA = 'LEA',
}
